import { getDayCountOfMonth } from 'element-ui/lib/utils/date-util';
import moment from 'moment';

const getYears = () => {
  const rows = [];

  // marqeta age limit is 13 years
  for (let year = new Date().getFullYear() - 13; year !== null;) {
    const row = [];

    for (let i = 0; i < 5; i += 1, year = (year > 1901 ? year - 1 : null)) {
      row.push(year);
    }

    rows.push(row);
  }

  return rows;
};

const getMonths = [
  ['Jan', 'Feb', 'Mar', 'Apr'],
  ['May', 'Jun', 'Jul', 'Aug'],
  ['Sep', 'Oct', 'Nov', 'Dec'],
];

const getMonthsObj = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11,
};

const getDates = (year, month) => {
  const dayCountOfMonth = getDayCountOfMonth(year, getMonthsObj[month]);

  const dayNumber = moment({ year, month: getMonthsObj[month], day: 1 }).day();

  const rows = [];
  let cellNum = 0;

  // Dates placed in 7 columns and 5 rows

  for (let x = 0; x < 6; x += 1) {
    let columns = 7;
    const row = [];
    if (x === 0) {
      for (let y = 0; y < dayNumber; y += 1) {
        row.push('');
      }
      columns -= dayNumber;
      for (let y = 0; y < columns; y += 1) {
        if (cellNum < dayCountOfMonth) {
          row.push(cellNum += 1);
        }
      }
    } else {
      for (let y = 0; y < columns; y += 1) {
        if (cellNum < dayCountOfMonth) {
          row.push(cellNum += 1);
        }
      }
    }


    rows.push(row);
  }

  // console.log(rows);
  // above given for-loop will generate array like this:
  // [
  //   [1, 2, 3, 4, 5, 6, 7],
  //   [8, 9, 10, 10, 12, 13, 14],
  //   [15, 16, 17, 18, 19, 20, 21],
  //   [22, 23, 24, 25, 25, 27, 28],
  //   [29, 30, 31, null, null, null, null],
  // ];

  return rows;
};


export {
  getYears,
  getMonths,
  getMonthsObj,
  getDates,
};
